module.exports = __webpack_public_path__ + "img/malcolm_brown.3e2a9f10.png";